import React, { useState } from "react";
import Image from "next/image";

function CollapseClose() {
  const [isAnsVisible, setIsAnsVisible] = useState(false);

  const toggleAnsVisibility = () => {
    if (isAnsVisible) setIsAnsVisible(false);
    else setIsAnsVisible(true);
  };

  return (
    <div className="py-[2rem] border-b-[1px] border-[#CBD0D6]">
      <div
        className="flex justify-between items-center cursor-pointer"
        onClick={toggleAnsVisibility}
      >
        <h4 className="text-[1.25rem] leading[2rem]">
          I forgot my password. What can I do now?
        </h4>

        <div className="min-w-[14px] ml-[1.625rem]">
          <Image
            src={`${
              isAnsVisible
                ? "/assets/icons/red-minus.svg"
                : "/assets/icons/red-plus.svg"
            }`}
            width={14}
            height={14}
            alt="auth-image"
          />
        </div>
      </div>
      <div className={`${isAnsVisible ? "" : "hidden"}`}>
        <p className="text-grayD3 text-body1 mt-[1.5rem]">
          If you have forgotten your password,
        </p>

        <ul className="list-disc ml-[2rem] text-grayD3">
          <li>
            Visit
            <a
              href="https://www.amarpet.com"
              target="_blank"
              rel="noreferrer"
              className="text-darkPrimary"
            >
              {" "}
              www.amarpet.com
            </a>
          </li>
          <li>Click on the ‘sign in’ button.</li>
          <li>
            You will be redirected to a page where there will be a ‘Forgot my
            password’ option. Click on that button. You will be redirected to a
            new page.
          </li>
          <li>
            You will be required to fill up a field mentioning your email
            address which was used during the registration at AmarPet.
          </li>
          <li>You will receive a new password in your email inbox.</li>
          <li>Sign in using the new password.</li>
        </ul>
      </div>
    </div>
  );
}

export default CollapseClose;
